<template>
  <v-card-text class="py-0" v-if="tariffStructure">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="2">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <z-vehicle-type-select v-model="tariffStructure.vehicleType" />
              </v-col>
              <!-- <v-col cols="12" sm="12" md="6" lg="12">
                <v-text-field
                  :label="$i18n.t('Min Trip Duration Hrs')"
                  v-model="tariffStructure.minDuration"
                  type="number"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="12">
                <v-text-field
                  :label="$i18n.t('Max Trip Duration Hrs')"
                  v-model="tariffStructure.maxDuration"
                  type="number"
                />
              </v-col>-->
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="10">
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="2">
                <v-text-field
                  :label="$i18n.t('Base Fare')"
                  v-model="tariffStructure.baseFare"
                  type="number"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="2">
                <v-text-field
                  :label="$i18n.t('Alloted KMs')"
                  v-model="tariffStructure.allotedKMs"
                  type="number"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="2">
                <v-text-field
                  :label="$i18n.t('KM Fare')"
                  v-model="tariffStructure.kmFare"
                  type="number"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="2">
                <v-text-field
                  :label="$i18n.t('Alloted Waiting Time (Hrs)')"
                  v-model="tariffStructure.allottedWaitingTime"
                  type="number"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="2">
                <v-text-field
                  :label="$i18n.t('Waiting Time Fare')"
                  v-model="tariffStructure.waitingTimeFare"
                  type="number"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="2">
                <v-btn
                  text
                  fab
                  small
                  color="red"
                  v-on:click="remove(tariffObj.tariffStructures, index)"
                  style="float:right"
                >
                  <v-icon>mdi-cancel</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="2" v-if="tariffObj.partLoad">
                <v-text-field
                  :label="$i18n.t('Per KG Fare')"
                  v-model="tariffStructure.farePerKg"
                  type="number"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="2" v-if="tariffObj.partLoad">
                <v-text-field
                  :label="$i18n.t('Per Cubic Feet Fare')"
                  v-model="tariffStructure.farePerCubicFeet"
                  type="number"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="4" lg="2" v-if="tariffObj.fuelSurcharge == true">
                <v-select
                  :label="$i18n.t('Fuel Surcharge Type')"
                  :items="fuelSurgTypes"
                  v-model="tariffStructure.fuelFare.fareType"
                  item-text="name"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="4"
                lg="2"
                v-if="
                  tariffObj.fuelSurcharge == true &&
                    (tariffStructure.fuelFare.fareType == 2 ||
                      tariffStructure.fuelFare.fareType == 1)
                "
              >
                <v-select
                  :label="$i18n.t('Fuel Type')"
                  :items="fuelTypes"
                  v-model="tariffStructure.fuelFare.fuelType"
                  item-text="name"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="4"
                lg="2"
                v-if="
                  tariffObj.fuelSurcharge == true &&
                    (tariffStructure.fuelFare.fareType == 2 ||
                      tariffStructure.fuelFare.fareType == 1)
                "
              >
                <v-text-field
                  :label="$i18n.t('Mileage')"
                  v-model="tariffStructure.fuelFare.mileage"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="4"
                lg="2"
                v-if="
                  tariffObj.fuelSurcharge == true &&
                    (tariffStructure.fuelFare.fareType == 2 ||
                      tariffStructure.fuelFare.fareType == 1)
                "
              >
                <v-text-field
                  :label="$i18n.t('Agreed Rate')"
                  v-model="tariffStructure.fuelFare.agreedRate"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="4"
                lg="2"
                v-if="
                  tariffObj.fuelSurcharge == true &&
                    tariffStructure.fuelFare.fareType == 2
                "
              >
                <v-text-field
                  :label="$i18n.t('Slab Amount')"
                  v-model="tariffStructure.fuelFare.slab"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="4"
                lg="2"
                v-if="
                  tariffObj.fuelSurcharge == true &&
                    tariffStructure.fuelFare.fareType == 2
                "
              >
                <v-text-field
                  v-if="tariffStructure.fuelFare.fareType == 2"
                  :label="$i18n.t('Amount')"
                  v-model="tariffStructure.fuelFare.amt"
                  type="number"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "TariffStructure",
  props: {
    value: {
      default: null,
    },
    tariffObj: {
      default: null,
    },
    index: {
      default: null,
    },
  },
})
export default class TariffStructureRow extends Vue {
  tariffStructure = null;

  @Watch("tariffObj.partLoad")
  onPartLoadChange() {
    this.tariffStructure.farePerKg = null;
    this.tariffStructure.farePerCubicFeet = null;
  }

  tsValidationRules = {
    kmFare: [
      (v) => {
        if (
          !v &&
          (this.tariffObj.garageToGarage || this.tariffObj.returnFareApplicable)
        ) {
          return this.$i18n.t("Per Km Fare is required");
        } else {
          return true;
        }
      },
    ],
  };

  years = [
    2001,
    2002,
    2003,
    2004,
    2005,
    2006,
    2007,
    2008,
    2009,
    2010,
    2011,
    2012,
    2013,
    2014,
    2015,
    2016,
    2017,
    2018,
    2019,
    2020,
  ];

  transmissions = [
    {
      name: "Manual",
      value: 1,
    },
    {
      name: "Automatic",
      value: 2,
    },
    {
      name: "Auto Pilot",
      value: 3,
    },
  ];

  fuelTypes = [
    {
      name: "Diesel",
      value: 1,
    },
    {
      name: "Petrol",
      value: 2,
    },
    {
      name: "CNG",
      value: 3,
    },
    {
      name: "Electricity",
      value: 4,
    },
  ];

  fuelSurgTypes = [
    {
      name: "Based on Actual",
      value: 1,
    },
    {
      name: "Surcharge by Slab",
      value: 2,
    },
  ];

  remove(list, index) {
    if (list && index != null && index != undefined) {
      list.splice(index, 1);
    }
  }

  async mounted() {
    if (this.value) {
      this.tariffStructure = this.value;

      if (!this.tariffStructure.fuelFare) this.tariffStructure.fuelFare = {};
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.tariffStructure = val;
  }
}
</script>
